import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";

const BrandIcons = () => {
  const navigate = useNavigate();
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loading, setLoading] = useState(false);

  // Animation Variants
  const iconVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.08, duration: 0.4 },
    }),
    tap: { scale: 0.95 },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const brandIcons = [
    // { name: "MERCEDES BENZ", image: "Brand_Mercedes.svg" },
    // { name: "BMW", image: "Brand_BMW.svg" },
    // { name: "Audi", image: "Brand_Audi.svg" },
    // { name: "Seat", image: "Brand_Seat.svg" },
    // { name: "Toyota", image: "Brand_Toyota.svg" },
    // { name: "Alfaromeo", image: "Brand_Alfa_Romeo.svg" },
    // { name: "Aston_Martin", image: "Brand_Aston_Martin.svg" },
    // { name: "Chevrolet", image: "Brand_Chevrolet.svg" },
    // { name: "Bentely", image: "Brand_Bentley.svg" },
    // { name: "Citroen", image: "Brand_Citroen.svg" },
    // { name: "Fiat", image: "Brand_Fiat.svg" },
    // { name: "Hyundai", image: "Brand_Hyundai.svg" },
      { name: "MERCEDES BENZ", image: "Brand_Mercedes.svg" },
      { name: "BMW", image: "Brand_BMW.svg" },
      { name: "AUDI", image: "Brand_Audi.svg" },
      // { name: "SEAT", image: "Brand_Seat.svg" },
      { name: "MAZDA", image: "Brand_Mazda.svg" },
      { name: "TOYOTA", image: "Brand_Toyota.svg" },
      { name: "ALFAROMEO", image: "Brand_Alfa_Romeo.svg" },
      { name: "ASTON_MARTIN", image: "Brand_Aston_Martin.svg" },
      { name: "CHEVROLET", image: "Brand_Chevrolet.svg" },
      { name: "BENTLEY", image: "Brand_Bentley.svg" },
      { name: "CITROEN", image: "Brand_Citroen.svg" },
      { name: "FIAT", image: "Brand_Fiat.svg" },
      { name: "HYUNDAI", image: "Brand_Hyundai.svg" }
  ];

  // Map to get exact brand names as they appear in your system
  const getBrandNameForAPI = (brandName) => {
    const brandNameMap = {
      "Mercedes": "Mercedes",
      "BMW": "BMW",
      "AUDI": "AUDI",
      "SEAT": "SEAT",
      "TOYOTA": "TOYOTA",
      "ALFAROMEO": "ALFAROMEO",
      "ASTON_MARTIN": "ASTON MARTIN",
      "CHEVROLET": "CHEVROLET",
      "BENTLEY": "BENTLEY",
      "CITROEN": "CITROEN",
      "FIAT": "FIAT",
      "HYUNDAI": "HYUNDAI",
    };
    return brandNameMap[brandName] || brandName;
  };

  // Handle brand click - WORKING SOLUTION using advance-filter-new API
  const handleBrandClick = async (brandName) => {
    setSelectedBrand(brandName);
    setLoading(true);

    const apiFormattedBrandName = getBrandNameForAPI(brandName);
    console.log("Selected Brand:", brandName);
    console.log("API Brand Name:", apiFormattedBrandName);

    try {
      // Using the WORKING API endpoint that you use elsewhere
      const response = await axios.get(
        "https://car.amar.co.jp/api/dashboard/filter/advance-filter-new",
        {
          params: {
            brandName: apiFormattedBrandName,
            page: "0",
            size: "100",
          },
          headers: {
            Accept: "application/json",
            "Accept-Language": "en",
          },
          timeout: 20000, // 20 second timeout
        }
      );

      console.log("Full API Response:", response);
      console.log("Response Data:", response.data);

      // Extract models from response
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        const uniqueModels = Array.from(
          new Set(
            response.data.data
              .map((item) => item.carModelName)
              .filter((modelName) => modelName && modelName.trim() !== "")
          )
        ).map((modelName) => ({
          carModelName: modelName,
        }));

        console.log("Extracted Models:", uniqueModels);

        // navigate(`/brand/${encodeURIComponent(brandName)}`, {
        //   state: {
        //     models: uniqueModels,
        //     brandName: apiFormattedBrandName,
        //     success: true,
        //   },
        // });
        navigate(`/brand/${encodeURIComponent(brandName)}`, {
          state: {
            models: uniqueModels,
            brandName: apiFormattedBrandName,
            success: true,
            // ✅ YE ADD KARO
            filterState: {
              selectedBrand: { label: apiFormattedBrandName },
              selectedCategory: null,
              selectedModels: [],
              selectedYears: [],
            },
          },
        });
      } else {
        // If response structure is different, still navigate
        console.warn("Unexpected response structure. Navigating anyway.");
        navigate(`/brand/${encodeURIComponent(brandName)}`, {
          state: {
            models: response.data?.data || [],
            brandName: apiFormattedBrandName,
            success: true,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching models:", error.message);
      console.error("Error Config:", error.config);
      console.error("Error Response:", error.response?.data);

      // IMPORTANT: Navigate anyway - don't block user
      // navigate(`/brand/${encodeURIComponent(brandName)}`, {
      //   state: {
      //     models: [],
      //     brandName: apiFormattedBrandName,
      //     success: false,
      //     error: "Unable to load models. You can still browse.",
      //   },
      // });
      navigate(`/brand/${encodeURIComponent(brandName)}`, {
        state: {
          models: [],
          brandName: apiFormattedBrandName,
          success: false,
          error: "Unable to load models. You can still browse.",
          // ✅ YE ADD KARO
          filterState: {
            selectedBrand: { label: apiFormattedBrandName },
            selectedCategory: null,
            selectedModels: [],
            selectedYears: [],
          },
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Top horizontal line */}
      <Box sx={{ width: "100%", height: "1px", backgroundColor: "#DCDCDC" }} />

      {/* Mobile Layout (xs - 4 brands per row, 2 rows total = 8 brands) */}
      <Box sx={{ display: { xs: "block", sm: "none" }, backgroundColor: "#FDFDFD" }}>
        {/* Mobile Brand Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Grid container spacing={1} sx={{ padding: "8px 12px" }}>
            {brandIcons.slice(0, 8).map((brand, index) => (
              <Grid item xs={3} key={brand.name}>
                <motion.div
                  custom={index}
                  variants={iconVariants}
                  whileTap="tap"
                  onClick={() => {
                    if (!loading) {
                      handleBrandClick(brand.name);
                    }
                  }}
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading && selectedBrand !== brand.name ? 0.5 : 1,
                    pointerEvents: loading ? "none" : "auto",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "8px",
                      padding: "12px 8px",
                      borderRadius: "10px",
                      transition: "all 0.2s ease",
                      backgroundColor: "#FFF",
                      border: "1px solid #F0F0F0",
                      "&:active": {
                        backgroundColor: "#F8F8F8",
                        border: "1px solid #E0E0E0",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={`/BrandIcons/${brand.image}`}
                      alt={brand.name}
                      sx={{
                        width: "44px",
                        height: "44px",
                        objectFit: "contain",
                      }}
                    />
                    <Box
                      sx={{
                        fontSize: "10px",
                        fontWeight: "600",
                        color: "#666",
                        textAlign: "center",
                        lineHeight: "1.2",
                        minHeight: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {brand.name.replace(/_/g, " ")}
                    </Box>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>

        {/* Mobile All Brands Button */}
        <Box sx={{ padding: "12px 12px 16px 12px" }}>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Button
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                // backgroundColor: loading ? "#999" : "#000",
                backgroundColor:"red",
                color: "#fff",
                textTransform: "none",
                padding: "11px 16px",
                fontSize: "13px",
                fontWeight: "600",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                cursor: loading ? "wait" : "pointer",
                // "&:active": {
                //   backgroundColor: "#1a1a1a",
                //   boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                // },
              }}
              onClick={() => navigate("/brand")}
            >
              {loading ? "Loading..." : "View All Brands"}
            </Button>
          </motion.div>
        </Box>
      </Box>

      {/* Desktop Layout (sm and above) */}
      <Box sx={{ display: { xs: "none", sm: "block" }, backgroundColor: "#FDFDFD" }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { sm: "12px", md: "20px" },
            justifyContent: "space-evenly",
            alignItems: "center",
            padding: "20px 0px",
          }}
        >
          {brandIcons.map((brand, index) => (
            <motion.div
              key={brand.name}
              custom={index}
              variants={iconVariants}
              initial="hidden"
              animate="visible"
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                if (!loading) {
                  handleBrandClick(brand.name);
                }
              }}
              style={{
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading && selectedBrand !== brand.name ? 0.5 : 1,
                pointerEvents: loading ? "none" : "auto",
              }}
            >
              <Box
                component="img"
                src={`/BrandIcons/${brand.image}`}
                alt={brand.name}
                sx={{
                  width: "auto",
                  height: { sm: "35px", md: "40px" },
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter: "brightness(1.1)",
                  },
                }}
              />
            </motion.div>
          ))}

          {/* Desktop Button */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              variant="outlined"
              disabled={loading}
              sx={{
                whiteSpace: "nowrap",
                border: "1px solid #ddd",
                backgroundColor: "transparent",
                color: "#000",
                textTransform: "none",
                padding: "8px 16px",
                cursor: loading ? "wait" : "pointer",
                "&:hover": {
                  backgroundColor: loading ? "transparent" : "#f5f5f5",
                  border: "1px solid #999",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                },
              }}
              onClick={() => navigate("/brand")}
            >
              {loading ? "Loading..." : "All Brands"}
            </Button>
          </motion.div>
        </Box>
      </Box>

      {/* Bottom horizontal line */}
      <Box sx={{ width: "100%", height: "1px", backgroundColor: "#DCDCDC" }} />
    </Box>
  );
};

export default BrandIcons;